function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "9antaumbba",
  d: "M0 0h100v68.047H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "inherit"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 32.908)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "0bhx1aa98b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9antaumbba"
})), /*#__PURE__*/React.createElement("path", {
  d: "M78.662 61.464c-3.184 0-5.838-2.654-5.838-5.838 0-3.185 2.654-5.84 5.838-5.84 3.185 0 5.84 2.655 5.84 5.84 0 3.184-2.655 5.838-5.84 5.838zM65.18 30.467V17.516H72.4c2.123 0 3.927 1.273 4.564 3.29l3.29 9.767H65.18v-.106zM21.338 61.464c-3.185 0-5.839-2.654-5.839-5.838 0-3.185 2.654-5.84 5.839-5.84 3.185 0 5.839 2.655 5.839 5.84 0 3.184-2.654 5.838-5.84 5.838zm75.158-27.919-9.129-1.91-4.246-12.951C81.635 14.12 77.282 11.04 72.4 11.04H65.18V4.353C65.181 1.91 63.271 0 60.83 0H51.38c-2.123 4.671-5.095 10.51-9.448 18.046-1.91 3.291-5.52 5.414-9.342 5.414-3.822 0-7.43-2.017-9.235-5.414C19.003 10.51 15.925 4.671 13.908 0H4.353C1.91 0 0 1.912 0 4.354v47.028c0 2.44 1.91 4.352 4.353 4.352h4.67c0 6.794 5.521 12.314 12.315 12.314s12.314-5.52 12.314-12.314h32.802c0 6.794 5.52 12.314 12.315 12.314 6.794 0 12.314-5.52 12.314-12.314h4.564c2.442 0 4.353-1.91 4.353-4.352V37.686c-.107-2.016-1.486-3.822-3.503-4.14z",
  mask: "url(#0bhx1aa98b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.842 16.773a7.838 7.838 0 0 1 7.855-7.856 7.838 7.838 0 0 1 7.856 7.856 7.838 7.838 0 0 1-7.856 7.855 7.838 7.838 0 0 1-7.855-7.855zm11.145 30.785c4.884-8.493 13.376-24.204 13.376-30.785C49.363 7.537 41.825 0 32.59 0c-9.234 0-16.666 7.537-16.666 16.773 0 6.581 8.493 22.292 13.376 30.785 1.487 2.548 5.201 2.548 6.688 0z"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 101,
  viewBox: "0 0 100 101",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/tracking-big.bc77ddc4.svg";
export { SvgComponent as ReactComponent };